import { Stack, Typography, Paper, LinearProgress } from "@mui/material";

export const LoadingState = () => (
  <Stack spacing={1}>
    <Typography fontWeight={500} variant="body2">
      Kontaktvägar
    </Typography>
    <Paper variant="outlined" sx={{ maxHeight: 200 }}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        p={2}
      >
        <LinearProgress sx={{ width: "100%" }} />
      </Stack>
    </Paper>
  </Stack>
);
